import React from 'react';
import './AutocompleteItem.less';

export const AutocompleteItem = ({text}) => {
	return <span className="autocomplete-item">{text}</span>
}
